import { createAction, props } from '@ngrx/store';
import {
  TrainingRequirementSkeleton,
  PagedTrainingRequirementAudit,
  PagedWarningRuleAudit,
  PagedBusinessPersonTrainingRequirementAudit,
  BusinessPersonWithTrainingSkeleton,
  PagedTrainingGroupAudit,
  TrainingGroupSkeleton,
  PagedTrainingGroupTrainingRequirementAudit
} from '../../+models/training-requirement-audit.model';

export const ResetTrainingRequirement = createAction('[SharedAudit TrainingRequirement] Reset');

export const ResetTrainingRequirementAudit = createAction(
  '[SharedAudit TrainingRequirement] Reset Audit'
);

export const LoadTrainingRequirementSkeletons = createAction(
  '[SharedAudit TrainingRequirement] Load Training Requirement Skeletons'
);

export const TrainingRequirementSkeletonsLoaded = createAction(
  '[SharedAudit TrainingRequirement] Training Requirement Skeletons Loaded',
  props<{ payload: TrainingRequirementSkeleton[] }>()
);

export const TrainingRequirementSkeletonsLoadError = createAction(
  '[SharedAudit TrainingRequirement] Training Requirement Skeletons Load Error',
  props<{ err: any }>()
);

export const LoadBusinessPersonWithTrainingSkeletons = createAction(
  '[SharedAudit TrainingRequirement] Load BusinessPerson With Training Skeletons'
);

export const BusinessPersonWithTrainingSkeletonsLoaded = createAction(
  '[SharedAudit TrainingRequirement] BusinessPerson With Training Skeletons Loaded',
  props<{ payload: BusinessPersonWithTrainingSkeleton[] }>()
);

export const BusinessPersonWithTrainingSkeletonsLoadError = createAction(
  '[SharedAudit TrainingRequirement] BusinessPerson With Training Skeletons Load Error',
  props<{ err: any }>()
);

export const LoadTrainingGroupSkeletons = createAction(
  '[SharedAudit TrainingRequirement] Load Training Group Skeletons'
);

export const TrainingGroupSkeletonsLoaded = createAction(
  '[SharedAudit TrainingRequirement] Training Group Skeletons Loaded',
  props<{ payload: TrainingGroupSkeleton[] }>()
);

export const TrainingGroupSkeletonsLoadError = createAction(
  '[SharedAudit TrainingRequirement] Training Group Skeletons Load Error',
  props<{ err: any }>()
);

// Training Requirement
export const LoadTrainingRequirementAudit = createAction(
  '[SharedAudit TrainingRequirement] Load Training Requirement Audit',
  props<{ trainingRequirementId: number }>()
);

export const LoadNextPageTrainingRequirementAudit = createAction(
  '[SharedAudit TrainingRequirement] Load NextPage Training RequirementAudit',
  props<{ trainingRequirementId: number }>()
);

export const TrainingRequirementAuditLoaded = createAction(
  '[SharedAudit TrainingRequirement] Training Requirement Audit Loaded',
  props<{ trainingRequirementId: number; audits: PagedTrainingRequirementAudit }>()
);

export const TrainingRequirementAuditLoadError = createAction(
  '[SharedAudit TrainingRequirement] Training Requirement Audit Load Error',
  props<{ err: any }>()
);

// Training Group
export const LoadTrainingGroupAudit = createAction(
  '[SharedAudit TrainingRequirement] Load Training Group Audit',
  props<{ trainingGroupId: number }>()
);

export const LoadNextPageTrainingGroupAudit = createAction(
  '[SharedAudit TrainingRequirement] Load NextPage Training Group Audit',
  props<{ trainingGroupId: number }>()
);

export const TrainingGroupAuditLoaded = createAction(
  '[SharedAudit TrainingRequirement] Training Group Audit Loaded',
  props<{ trainingGroupId: number; audits: PagedTrainingGroupAudit }>()
);

export const TrainingGroupAuditLoadError = createAction(
  '[SharedAudit TrainingRequirement] Training Group Audit Load Error',
  props<{ err: any }>()
);

// Training Group Training Requirement Rule
export const LoadTrainingGroupTrainingRequirementAudit = createAction(
  '[SharedAudit TrainingRequirement] Load Training Group Training Requirement Rule Audit',
  props<{ trainingGroupTrainingRequirementId: number }>()
);

export const LoadNextPageTrainingGroupTrainingRequirementAudit = createAction(
  '[SharedAudit TrainingRequirement] Load NextPage Training Group Training Requirement Rule Audit',
  props<{ trainingGroupTrainingRequirementId: number }>()
);

export const TrainingGroupTrainingRequirementAuditLoaded = createAction(
  '[SharedAudit TrainingRequirement] Training Group Training Requirement Rule Audit Loaded',
  props<{
    trainingGroupTrainingRequirementId: number;
    audits: PagedTrainingGroupTrainingRequirementAudit;
  }>()
);

export const TrainingGroupTrainingRequirementAuditLoadError = createAction(
  '[SharedAudit TrainingRequirement] Training Group Training Requirement Rule Audit Load Error',
  props<{ err: any }>()
);

// Warning Rule
export const LoadWarningRuleAudit = createAction(
  '[SharedAudit TrainingRequirement] Load Warning Rule Audit',
  props<{ warningRuleId: number }>()
);

export const LoadNextPageWarningRuleAudit = createAction(
  '[SharedAudit TrainingRequirement] Load NextPage Warning Rule Audit',
  props<{ warningRuleId: number }>()
);

export const WarningRuleAuditLoaded = createAction(
  '[SharedAudit TrainingRequirement] Warning Rule Audit Loaded',
  props<{ warningRuleId: number; audits: PagedWarningRuleAudit }>()
);

export const WarningRuleAuditLoadError = createAction(
  '[SharedAudit TrainingRequirement] Warning Rule Audit Load Error',
  props<{ err: any }>()
);

// BusinessPersonTrainingRequirement
export const LoadBusinessPersonTrainingRequirementAudit = createAction(
  '[SharedAudit TrainingRequirement] Load BusinessPerson Training Requirement Audit',
  props<{ businessPersonTrainingRequirementId: number }>()
);

export const LoadNextPageBusinessPersonTrainingRequirementAudit = createAction(
  '[SharedAudit TrainingRequirement] Load NextPage BusinessPerson Training RequirementAudit',
  props<{ businessPersonTrainingRequirementId: number }>()
);

export const BusinessPersonTrainingRequirementAuditLoaded = createAction(
  '[SharedAudit TrainingRequirement] BusinessPerson Training Requirement Audit Loaded',
  props<{
    businessPersonTrainingRequirementId: number;
    audits: PagedBusinessPersonTrainingRequirementAudit;
  }>()
);

export const BusinessPersonTrainingRequirementAuditLoadError = createAction(
  '[SharedAudit TrainingRequirement] BusinessPersonTraining Requirement Audit Load Error',
  props<{ err: any }>()
);
